<template>
  <ol class="breadcrumb mt-[12px] md:mt-0">
    <li v-if="isFromReports === 1"
        class="breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
      <a style="text-underline: none;" href="/reports/manage"
         class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
        Отчет
      </a>
    </li>
    <li v-else
        class="breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
      <a style="text-underline: none;" href="/tasks/manage"
         class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
        Задачи
      </a>
    </li>
    <li class="breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
      <a :href="profileLink"> Мой профиль </a>
    </li>
  </ol>

  <div class="row justify-content-center">
    <div class="col-lg-8">
      <div class="card bg-white border-0 rounded-3 mb-2">
        <div class="card-body p-4">
          <form @submit.prevent>
            <div class="row g-1">
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-3">
                  <label class="label text-secondary">Имя и фамилия</label>
                  <input type="text" class="form-control h-55" v-model="newUser.name"/>
                </div>
              </div>

              <div class="col-lg-6 col-sm-6">
                <!-- Empty column for spacing -->
              </div>

              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-3">
                  <label class="label text-secondary">Телефон</label>
                  <input type="text" class="form-control h-55" v-model="newUser.phone"/>
                </div>
              </div>

              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-3">
                  <label class="label text-secondary">Email</label>
                  <input type="text" class="form-control h-55" v-model="newUser.email"/>
                </div>
              </div>

              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-3">
                  <label class="label text-secondary">Логин</label>
                  <input type="text" class="form-control h-55" v-model="newUser.username"/>
                </div>
              </div>

              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-3">
                  <label class="label text-secondary">Пароль</label>
                  <input type="text" class="form-control h-55" v-model="newUser.password"/>
                </div>
              </div>

              <div class="col-lg-12 col-sm-12" v-if="isFromReports===1">
                <div class="form-group mb-3">
                  <label class="label text-secondary">Предприятия</label>
                  <div class="d-flex align-items-center mb-2">
                    <input
                        type="text"
                        class="form-control h-55"
                        v-model="newFirma"
                        placeholder="Введите название предприятия"
                        @keydown.enter.prevent="addFirma"
                    />
                    <button
                        type="button"
                        class="btn btn-primary ms-2 h-55 d-flex align-items-center"
                        @click="addFirma"
                        :disabled="!newFirma.trim()"
                    >
                      <i class="material-icons">add</i>
                    </button>
                  </div>

                  <div class="firma-list">
                    <div
                        v-for="(firma, index) in firmas"
                        :key="index"
                        class="d-flex align-items-center mb-2"
                    >
                      <span class="form-control h-55 bg-light">{{ firma }}</span>
                      <button
                          type="button"
                          class="btn btn-danger ms-2 h-55 d-flex align-items-center"
                          @click="removeFirma(index)"
                      >
                        <i class="material-icons">delete</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-2">
                <div class="d-flex flex-wrap justify-content-between">
                  <button @click="!isEditPage ? createUser() : updateUser()"
                          class="btn btn-primary py-2 px-4 fw-medium fs-16">
                    Сохранить
                  </button>
                  <a :href="isFromReports === 1 ?  '/my-profile?is_from_reports=1' : '/my-profile'"
                     class="btn btn-default py-2 px-4 fw-medium fs-16">
                    Отменить
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <!-- Right sidebar content -->
    </div>
  </div>
</template>

<script>
import {useAuthStore} from "@/stores/auth";
import UserResource from '@/api/user';
import FlatPickr from "vue-flatpickr-component";

const userResource = new UserResource();

export default {
  name: "MyProfile",
  components: {
    FlatPickr,
  },
  data() {
    return {
      isFromReports: 0,
      flatpickrConfig: {
        dateFormat: 'Y-m-d',
        locale: 'ru',
        allowInput: true,
        altInput: true,
        altFormat: 'd-m-Y',
        static: false,
      },
      authStore: useAuthStore(),
      roles: ['Гранд Админ', 'Админ', 'Наблюдатель', 'Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Менеджер', 'Главный координатор'],
      rolesForAdmin: ['Админ', 'Наблюдатель', 'Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Менеджер', 'Главный координатор'],
      rolesForManager: ['Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Главный координатор'],
      rolesForCoordinatorMain: ['Координатор'],
      newUser: {
        username: this.generateUsername(),
        password: this.generateRandomPassword(8),
        passport: null,
        pesel: null,
        phone: null,
        created_at: null,
        retired_at: null,
        is_student: 0,
        firma: ''
      },
      newFirma: '',
      firmas: [],
      selectedCoordinators: [],
      isEditPage: false
    };
  },
  methods: {
    createUser() {
      this.updateFirmaString(); // Ensure firma string is up to date
      this.newUser.roles = [this.newUser.role];
      userResource
          .store(this.newUser)
          .then(response => {
            this.isFromReports === 1 ? window.location.href = '/reports/manage' : window.location.href = '/tasks/manage'
          })
          .catch(error => {
            console.log(error);
            this.isFromReports === 1 ? window.location.href = '/reports/manage' : window.location.href = '/tasks/manage'
          })
    },
    updateUser() {
      this.updateFirmaString(); // Ensure firma string is up to date
      userResource
          .update(this.newUser.id, this.newUser)
          .then(response => {
            this.isFromReports === 1 ? window.location.href = '/reports/manage' : window.location.href = '/tasks/manage'
          })
          .catch(error => {
            console.log(error)
            this.isFromReports === 1 ? window.location.href = '/reports/manage' : window.location.href = '/tasks/manage'
          });
    },
    generateUsername(length = 8) {
      return 'hr-' + [...Array(length)].map(() => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789'[Math.floor(Math.random() * 61)]).join('');
    },
    generateRandomPassword(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+|:?>';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    addFirma() {
      if (this.newFirma.trim() && !this.firmas.includes(this.newFirma.trim())) {
        this.firmas.push(this.newFirma.trim());
        this.newFirma = '';
        this.updateFirmaString();
      }
    },
    removeFirma(index) {
      this.firmas.splice(index, 1);
      this.updateFirmaString();
    },
    updateFirmaString() {
      this.newUser.firma = this.firmas.join(', ');
    },
    parseFirmaString() {
      if (this.newUser.firma) {
        this.firmas = this.newUser.firma.split(',').map(item => item.trim()).filter(item => item);
      } else {
        this.firmas = [];
      }
    }
  },
  async created() {
    this.isFromReports = this.$route.query.is_from_reports === '1' ? 1 : 0;
    const path = this.$route.path;
    if (path.includes('/edit/')) {
      this.isEditPage = true;
      const id = path.split('/edit/')[1];
      const data = await userResource.get(id);
      this.newUser = data.data;
      this.newUserid = id;
      this.parseFirmaString();
    } else {
      this.isEditPage = false;
      console.log('Create mode');
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 95%;
  margin: 10px auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.row.justify-content-center {
  background-color: transparent;
}

.card {
  background-color: #fff;
  border-radius: 8px;
}

.btn {
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #3b7ddd;
  border-color: #3b7ddd;
}

.btn-default {
  background-color: #f5f5f5;
  border-color: #ddd;
  color: #333;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
}

.label {
  font-size: 14px;
  margin-bottom: 6px;
  display: block;
}

.firma-list {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 10px;
}

.firma-list > div {
  transition: all 0.3s ease;
}

.btn {
  min-width: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.material-icons {
  font-size: 18px;
}

.bg-light {
  background-color: #f8f9fa;
}
</style>